import report from './report';

const data = {
  report,
};

export default data;
